import { type ReactNode } from 'react';
import './TabbedContent.css';

type Tab = {
  tabId: number;
  tabName: string;
};

interface TabbedContentProps {
  tabs: Tab[];
  children: ReactNode[];
  activeTab: number;
  onTabChange: (tabId: number) => void;
}

export const TabbedContent = ({ tabs, children, activeTab, onTabChange }: TabbedContentProps) => {
  const handleTabClick = (tabId: number) => {
    onTabChange(tabId);
  };

  return (
    <div className="p-4">
      <div className="flex gap-2 pl-4">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.tabId;
          return (
            <button
              key={tab.tabId}
              onClick={() => handleTabClick(tab.tabId)}
              className={`relative font-sans text-cds-2 font-semibold leading-[22px] px-5 pt-2 pb-[11px] rounded-[20px] bg-white text-cds-on-surface-3 focus:outline-none transition-colors tab-trigger`}
            >
              <span>{tab.tabName}</span>
              {isActive && (
                <span
                  aria-hidden="true"
                  className="absolute left-1/2 bottom-0 h-[3px] rounded-[2px] tab-underline"
                />
              )}
            </button>
          );
        })}
      </div>
      <div className="p-4">
        {children.map((child, index) => {
          const tabId = tabs[index]?.tabId ?? 0;
          const hidden = activeTab !== tabId;
          return (
            <div
              key={index}
              className={`tab-panel ${hidden ? 'is-hidden' : ''}`}
            >
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
};
